import React from 'react';
import { addCustomReminder, addDateZeroes, customReminderHelpers, deleteCustomReminder, reminderChangeHandler, reminderHelpers } from './reminder-helpers';
import { Button } from "react-bootstrap";
import DropdownMain from "../../../../../../components/dropdown-main/DropdownMain";
import { FluentTime } from "../../../../../../components/FluentUI/Fluent-Time";
import "../../../task-types/dynamic-fields/dynamic-fields-page/admin-dynamic-fields-page.scss";
import PropTypes from 'prop-types';

const CustomReminders = ({ taskReminder, customReminders, setCustomReminders }) => {

    return (
        <div className="overflowFix admin-dynamic-fields-page-wrapper">
            <div className="customReminderContainer">
                {customReminders?.length > 0 ? (
                    <table>
                        <thead>
                            <tr>
                                <th>REMINDER NAME (optional)</th>
                                <th>UNIT</th>
                                <th>PERIOD</th>
                                <th>DATE</th>
                                <th>TIME (Local)</th>
                                <th>TIME (UTC)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {customReminders.map((cr, idx) => (
                                <tr className="reminderRow" key={cr.Id}>
                                    <td className="reminderName">
                                        <div className="reminderInputContainer">
                                            <span className="reminderIndex">{idx + 1}</span>
                                            <input
                                                type="text"
                                                value={cr.Name}
                                                onChange={(e) => {
                                                    reminderChangeHandler(
                                                        "Name",
                                                        e.target.value,
                                                        idx, customReminders, setCustomReminders
                                                    );
                                                }}
                                                placeholder="For example, Follow-up #1, Reminder #1, etc."
                                                maxLength={56}
                                                disabled={!taskReminder.exist}
                                            />
                                        </div>
                                        <div className="reminder-name-character-text">
                                            Enter a maximum of 56 characters.
                                        </div>

                                    </td>
                                    <td className="reminderUnits">
                                        <input
                                            value={cr.Unit}
                                            type="number"
                                            defaultValue={2}
                                            min={1}
                                            required
                                            onKeyDown={(e) => {
                                                (e.key === "Enter" ||
                                                    e.key === "." ||
                                                    e.key === "-") &&
                                                    e.preventDefault();
                                            }}
                                            onChange={(e) => {
                                                reminderChangeHandler(
                                                    "Unit",
                                                    e.target.value,
                                                    idx, customReminders, setCustomReminders
                                                );
                                            }}
                                            onBlur={(e) => {
                                                if (e.target.value == 0) {
                                                    e.target.value = 1;
                                                    reminderChangeHandler(
                                                        "Unit",
                                                        e.target.value,
                                                        idx, customReminders, setCustomReminders
                                                    );
                                                }
                                            }}
                                            disabled={!taskReminder.exist}
                                        />
                                    </td>
                                    <td className="reminderPeriod">
                                        <div className="row-dropdown">
                                            <DropdownMain
                                                values={
                                                    customReminderHelpers.reminderRecurringIntervalTypeValues
                                                }
                                                dropdownButtonText={"-Select-"}
                                                onSelect={(selectedValue) => {
                                                    reminderChangeHandler(
                                                        "Period",
                                                        selectedValue.id,
                                                        idx, customReminders, setCustomReminders
                                                    );
                                                }}
                                                currentSelected={{ name: cr.Period }}
                                                disabled={!taskReminder.exist}
                                                additonalClasses={
                                                    "overflowSetAbsolute dropdown-custom-reminders"
                                                }
                                                alignRight={true}
                                            />
                                        </div>
                                    </td>
                                    <td className="reminderType">
                                        <div className="reminder-dropdown">
                                            <DropdownMain
                                                values={
                                                    reminderHelpers.reminderValues
                                                }
                                                dropdownButtonText={"-Select-"}
                                                onSelect={(selectedValue) => {
                                                    reminderChangeHandler(
                                                        "ReminderType",
                                                        selectedValue.name,
                                                        idx, customReminders, setCustomReminders
                                                    );
                                                }}
                                                currentSelected={{
                                                    name: cr.ReminderType,
                                                }}
                                                disabled={!taskReminder.exist}
                                                additonalClasses={
                                                    "overflowSetAbsolute"
                                                }
                                                alignRight={true}
                                            />
                                        </div>
                                    </td>
                                    <td className="reminderTime">
                                        <div className="reminder-date-picker">
                                            <FluentTime
                                                value={new Date(cr.ReminderTime)}
                                                onChange={(value) =>
                                                    reminderChangeHandler(
                                                        "ReminderTime",
                                                        value,
                                                        idx, customReminders, setCustomReminders
                                                    )
                                                }
                                                timeIntervals={15}
                                                disabled={!taskReminder.exist}
                                            />
                                        </div>
                                    </td>
                                    <td className="reminderTimeUTC">
                                        <div>
                                            {`${addDateZeroes(new Date(cr.ReminderTime).getUTCHours(), true)}:${addDateZeroes(new Date(cr.ReminderTime).getMinutes(), false)}`}
                                        </div>
                                    </td>
                                    <td className="reminderDelete">
                                        <Button
                                            className="delete-icon btn-icon1 btn btn-primary"
                                            onClick={() => deleteCustomReminder(idx, customReminders, setCustomReminders)}
                                            type="button"
                                            disabled={!taskReminder.exist}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="emptyCustomReminder">
                        <h3>Custom Task Reminders</h3>
                        <p>
                            To set up Task Reminders with custom delivery
                            schedule, Click the Add New Reminder button
                            below
                        </p>
                    </div>
                )}
            </div>
            <div className="d-flex justify-content-between">
                <div>
                    {customReminders?.length != 0 && (
                        <h4 className="recurrence-details">
                            {customReminders?.length == 1
                                ? " 1 Task Reminder has been set"
                                : customReminders?.length +
                                " Task Reminders have been set"}
                        </h4>
                    )}
                </div>
                <button
                    className="newReminder btn"
                    onClick={() => addCustomReminder(customReminders, setCustomReminders)}
                >
                    <span className="add-reminder-btn-text">
                        Add New Reminder
                    </span>
                    <div className="add-field-icon" />
                </button>
            </div>
        </div>
    );
};

CustomReminders.propTypes = {
    taskReminder: PropTypes.shape({
        exist: PropTypes.bool,
    }),
    customReminders: PropTypes.arrayOf(PropTypes.shape({
        Id: PropTypes.number,
        Name: PropTypes.string,
        Unit: PropTypes.number,
        Period: PropTypes.string,
        ReminderTime: PropTypes.instanceOf(Date),
    })),
    setCustomReminders: PropTypes.func.isRequired,
};

export default CustomReminders;